import * as React from "react";
import { Header, Navigation, Filter, Footer } from "../../shared";
import { TableAnalytical } from "./TableAnalytical";
import "./BookstoreAnalytical.scss";

import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { Grid } from "@material-ui/core";
import { BookstoreCategoryFilter, BookstoreProviderFilter, BookstoreStoreFilter, BookstoreUfFilter, BookstoreProductFilter } from "src/component/bookstore/shared/filter/BookstoreFilter";
import { BookstoreFilterChip } from "src/component/bookstore/shared/chips/BookstoreFilterChip";

// tslint:disable-next-line:no-empty-interface
export interface IBookstoreAnalyticalProps {}

// tslint:disable-next-line:no-empty-interface
export interface IBookstoreAnalyticalState {}

export class BookstoreAnalytical extends React.Component<
  IBookstoreAnalyticalProps,
  IBookstoreAnalyticalState
> {
  constructor(props: IBookstoreAnalyticalProps) {
    super(props);
  }

  public render() {
    return (
      <div>
        <Header title={"Análises"} name={"Editoras"} link={"/bookstore/sale"} />
        <Navigation
          name={"Painel Analítico"}
          linkDefault={"/bookstore/sale"}
          link={"/bookstore/sale"}
          linkTitle={"Vendas"}
          painel={1}
          icon={<ChevronLeftIcon />}
        />
        <Filter
          filters={[
            <BookstoreCategoryFilter key={1} />,
            <BookstoreProviderFilter key={2} />,
            <BookstoreStoreFilter key={3} />,
            <BookstoreUfFilter key={4} />,
            <BookstoreProductFilter key={5} />
          ]}
        />

        <BookstoreFilterChip />

        <div className="wrapper">
          <Grid
            container={true}
            className="bookstore-sale-panel panel-grid"
            spacing={16}
          >
            <Grid item={true} xs={12} >
              <TableAnalytical />
            </Grid>
          </Grid>
        </div>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/bookstore/analytical/BookstoreAnalytical.tsx